<template>
	<div class="container">
		<div class="footer_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="top_box">
				<img src="../assets/img/logo_color.png" style="max-width: 150px;" @click="goIndex" />
			</div>
			<div class="footer_main">
				<div class="footer_el">
					<div class="footer_el_el">
						© {{ nowYear }} CorDx
					</div>
					<div class="footer_el_el">All Rights Reserved</div>
				</div>
				<div class="bot_box">
					<div class="share_box">
						<a href="https://www.linkedin.com/company/cordx/">
							<svg class="e-font-icon-svg e-fab-linkedin-in" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>
						</a>
					</div>
					<div class="share_box">
						<a href="https://twitter.com/cordx_us">
							<svg class="e-font-icon-svg e-fab-twitter" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
						</a>
					</div>
					<div class="share_box">
						<a href="https://tiktok.com/@cordxusa">
							<img src="../assets/img/tiktok.png" style="width: 20px;position: relative;top: -5px;" />
						</a>
					</div>
					<div class="share_box">
						<a href="https://www.youtube.com/@CorDx3721">
							<img src="../assets/img/youtube.png" style="width: 22px;position: relative;top: -4px;" />
						</a>
					</div>
				</div>
				<div class="footer_el">
					<div class="footer_el_el" @click="navHandle('/about')">About</div>
					<div class="footer_el_el" @click="navHandle('/partnering')">Partnering</div>
					<div class="footer_el_el" @click="navHandle('/product/all')">Products</div>
				</div>
				<div class="footer_el">
					<div class="footer_el_el" @click="navHandle('/careers')">Careers</div>
					<div class="footer_el_el" @click="navHandle('/contact')">Contact</div>
					<div class="footer_el_el" @click="navHandle('/media-room')">Media Room</div>
					<div class="footer_el_el">
						<a href="https://cordx.com/uploads/cordx_logo-pack_rev20220525.zip" style="color: #706B69 !important;font-size: 14px;">
							Media Kit
						</a>
					</div>
				</div>
				<div class="footer_el_b">
					<div v-if="false" class="tit" style="padding-bottom: 20px;">Sign up and receive 20% off your first order.</div>
					<iframe
						v-if="false"
						:src="formUrl"
						width="100%"
						height="380px"
						frameborder="0"
						allowfullscreen
					>
					</iframe>
					<!-- <div class="input_box">
						<div class="tit">Email</div>
						<input v-model="emailVal" :class="isClick && !emailVal ? 'error' : ''" />
						<div v-show="isClick && !emailVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">First name</div>
						<input v-model="firstVal" :class="isClick && !firstVal ? 'error' : ''" />
						<div v-show="isClick && !emailVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Last name</div>
						<input v-model="lastVal" :class="isClick && !lastVal ? 'error' : ''" />
						<div v-show="isClick && !lastVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div v-show="isClick && !lastVal && !firstVal && !emailVal" class="tips_box">
						<div class="error">Please complete all required fields.</div>
					</div>
					<div class="btn_box" @click="subClick">Subscribe</div> -->
				</div>
				<div class="privacy_box">
					<div class="privacy_el1" @click="goPrivacy1">Privacy Policy</div>
					<div class="privacy_el2" @click="goPrivacy2">Terms and Conditions</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { formSubmit } from '@/api/public';
import moment from 'moment';
export default {
	components:{
		//
	},
	data() {
		return {
			emailVal: '',
			firstVal: '',
			lastVal: '',
			isClick: false,
			formUrl: 'https://cordx.com/hbspt-form.html?t='+new Date().getTime(),
			nowYear: moment().format('YYYY')
		}
	},
	created(){
		//
	},
	mounted() {
		let that = this;
		
	},
	watch: {
		//
	},
	methods: {
		//跳转导航
		navHandle(value) {
			let that = this;
			if(that.$route.path != value) {
				that.$router.push({ path: value, });
			}
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.isShow = false;
				that.$router.push({ path: '/', });
			}
		},
		goPrivacy1() {
			this.$router.push({ path: '/privacy-policy', });
		},
		goPrivacy2() {
			this.$router.push({ path: '/terms-and-conditions', });
		},
		//点击提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				formSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					email: that.emailVal,
					source: 'Other',
					type: 'Contact Us',
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.isClick = false;
				});
			}
		},
	}
}
</script>

<style scoped>
/*版权*/
.footer_box{
	width: auto;
	max-width: 100%;
	margin: 0 auto;
	padding: 30px 20px 30px 20px;
	background-color: #ffffff;
	color: #ffffff;
	border-top: 1px solid #0B318F;
}
.footer_box .top_box{
	max-width: 150px;
}
.footer_box .share_box{
	display: inline-block;
	margin-right: 20px;
}
.footer_box .share_box svg{
	width: 20px;
	height: 20px;
	position: relative;
	display: block;
	fill: #0B318F;
}
.footer_box .footer_main{
	width: 100%;
	position: relative;
	margin-top: 30px;
}
.footer_box .footer_main .bot_box{
	padding: 30px 0 16px 0;
}
.footer_box .footer_el{
	width: 100%;
	padding-bottom: 12px;
}
.footer_box .footer_el .footer_el_el{
	padding-bottom: 12px;
	color: #000000;
}
.footer_box .footer_el_b{
	width: 100%;
}
.footer_box .footer_el_b .tit{
	color: #000000;
	font-size: 20px;
}
.footer_box .input_box .tit{
	margin-bottom: 8px;
	font-size: 14px;
	color: #0B318F;
}
.footer_box .input_box .tit::after{
	content: '*';
	color: #ff0000;
}
.footer_box .input_box input{
	width: 100%;
	background-color: #f5f8fa;
	color: #33475b;
	height: 42px;
	line-height: 21px;
	border: 1px solid #cbd6e2;
	padding: 10px;
}
.footer_box .input_box input.error{
	border-color: #c87872;
}
.footer_box .tips_box{
	margin-top: 8px;
}
.footer_box .tips_box .error{
	font-size: 14px;
	font-family: helvetica;
	color: #f2545b;
}
.footer_box .error_tit{
	color: #f2545b;
	font-size: 14px;
}
.footer_box .input_box_father{
	display: flex;
}
.footer_box .input_box{
	flex: 1;
	padding-bottom: 14px;
}
.footer_box .input_box_father .input_box:last-child{
	margin-left: 15px;
}
.footer_box .input_box_father .input_box:first-child{
	margin-right: 15px;
}
.footer_box .btn_box{
	display: inline-block;
	margin-top: 40px;
	padding: 10px 20px 10px 20px;
	text-align: center;
	background-color: #0B318F;
	cursor: pointer;
	color: #ffffff;
}
.footer_box .privacy_box{
	color: #333333;
}
.footer_box .privacy_box .privacy_el1{
	padding: 30px 0 20px 0;
}
.footer_box .privacy_box .privacy_el2{
	padding: 0 0 20px 0;
}
</style>
